<a class="round-button" [ngClass]="{'disable-hover': disableHover}">
  <span>
    <ng-content></ng-content>
  </span>
</a>


// WEBPACK FOOTER //
// ./src/app/shared/components/buttons/round-button/round-button.component.html